import { Direction } from 'matrix-js-sdk';
import { matrixClient } from '../../client';
import { messageUtils } from '../messageUtils';
import { IMatrixMessage } from '../../room/types';
// 你需要根据实际项目引入 matrix 客户端实例
// import { matrixClient } from '你的matrix客户端路径';


/**
 * 基于 event_id 向前翻历史消息
 * @param client MatrixClient 实例
 * @param roomId 房间ID
 * @param eventId 作为锚点的消息ID
 * @param limit 拉取条数
 * @returns 拉取到的 MatrixEvent[]，以及是否到达最早
 */
async function loadHistoryByEventId(roomId: string, eventId: string, limit: number = 20) {
    if(!matrixClient.client) return {
        events: [],
        isEnd: true,
        timeline: null,
    };
  // 1. 获取 Room 实例
  const room = await matrixClient.client.getRoom(roomId);
  if (!room) {
    throw new Error('Room not found: ' + roomId);
  }

  // 2. 获取 timelineSet
  const timelineSet = await room.getUnfilteredTimelineSet();
  if (!timelineSet) {
    throw new Error('timelineSet not found for room: ' + roomId);
  }

  // 3. 获取包含该 event 的 timeline
  const timeline = await matrixClient.client.getEventTimeline(timelineSet, eventId);
  if (!timeline) {
    throw new Error('timeline not found for event: ' + eventId);
  }

  // 4. 向前分页加载历史
  const hasMore = await matrixClient.client.paginateEventTimeline(timeline, {
    backwards: true,
    limit,
  });

  // 5. 获取 timeline 上的所有事件
  const events = await timeline.getEvents(); // Array<MatrixEvent>
  
  // 6. 提取 event 字段，转为 IMatrixMessage[]
  const messages = events
  .map(ev => ev.event)
  .filter(
    (ev): ev is {
      event_id: string;
      sender: string;
      content: any;
      origin_server_ts: number;
      type: string;
      unsigned?: any;
      room_id?: string;
    } =>
      !!ev &&
      typeof ev.event_id === 'string' &&
      typeof ev.sender === 'string' &&
      typeof ev.content === 'object' &&
      ev.content !== undefined &&
      typeof ev.origin_server_ts === 'number' &&
      typeof ev.type === 'string'
  )
  .map(ev => ({
    event_id: ev.event_id,
    sender: ev.sender,
    content: ev.content,
    origin_server_ts: ev.origin_server_ts,
    type: ev.type,
    unsigned: ev.unsigned,
    room_id: ev.room_id,
  })) as IMatrixMessage[];
  // 7. 批量写入本地消息池
  messageUtils.batchAddHistoryMessages(roomId, messages);
  // 6. 判断是否到达最早
  const isEnd = !hasMore;

  return {
    events,
    isEnd,
    timeline,
  };
}

export const matrixLoadHistory = {
  loadHistoryByEventId
}